module.exports = __webpack_public_path__ + "static/media/angieveguilla-2.2a109b79.jpg";